import { friendlyDateTime } from '../../../lib/datetime-helpers';

import NavItem from '../nav-link';

export default ({ switchProp, color, data, eventType = {}, backgroundText = `News ` }) => {
    const { name, description, start = null, slug = '', background } = data;

    const type = eventType?.name || data.event_type;

    const onClick = () => {
        window.location.href = slug;
    }

    let mappedText = [];
    for(let i = 0; i < 5; i ++) {
        mappedText.push(backgroundText);
    }

    return (
        <div className={`news-card ${switchProp} ${color ? 'news-card__color-' + color : '' }`} style={{ background: `url(${background})` }}>
            <div class="news-card__overlay">
                <div class="news-card__container">
                    <NavItem slug={slug} text="Discover" />

                    <p class="news-card__text">
                        {
                            <>
                                {
                                    mappedText.map(t => t)

                                }
                                <br />
                            </>
                        }

                    </p>
                   { switchProp == 'featured' && <div class="news-card__featured">Featured</div> }
                </div>
                <div class="news-card__container">
                    <div class="news-card__top" onClick={onClick}>
                        <b>{ name }</b>
                        <p>{ description }</p>
                    </div>
                    <div class="news-card__bottom">
                        { start !== null && <p>{ friendlyDateTime(start) }</p> }
                        <p>{ type }</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
